<template>
  <div class="highcharts-light user-details-usage-history-chart chart-container">
    <highcharts :options="chartOptions" ref="chartComponent"></highcharts>
  </div>
</template>

<script>
import _ from 'lodash';
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';

noDataToDisplay(Highcharts);

export default {
  name: 'user-details-usage-history-chart',
  components: {
    highcharts: Chart
  },
  props: {
    chartSeries: {
      type: Array,
      default: () => []
    },
    clickCallback: {
      type: Function,
      default: _.noop
    }
  },
  computed: {
    chartOptions: function() {
      let self = this;
      return {
        chart: {
          styledMode: true,
          height: 140
        },
        title: {
          text: undefined
        },
        time: {
          useUTC: false
        },
        lang: {
          noData: 'No Data To Display'
        },
        noData: {
          style: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif'
          }
        },
        legend: {
          itemStyle: {
            fontSize:'12px',
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif',
            fontWeight: '600'
          }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: self.clickCallback
              }
            },
            marker: {
              enabled: false
            }
          }
        },
        tooltip: {
          style: {
            color: '#253035',
            fontFamily: '"Forma DJR UI", Arial, sans-serif'
          },
          dateTimeLabelFormats: {
            day: '%e %b %Y',
            week: '%e %b %Y',
            month: '%b %Y'
          }
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: { // Format e.g. "Jul 4"
            day: '%b %e',
            week: '%b %e'
          },
          labels: {
            y: 22,
            style: {
              color: '#6d787e',
              fontSize: '12px',
              fontFamily: '"Forma DJR UI", Arial, sans-serif',
              fontWeight: '600'
            }
          }
        },
        yAxis: {
          title: {
            enabled: false
          },
          labels: {
            style: {
              color: '#253035',
              fontSize: '10px',
              fontFamily: '"Forma DJR UI", Arial, sans-serif'
            }
          }
        },
        series: self.chartSeries,
        credits: {
          enabled: false
        }
      }
    }
  },
  mounted() {
    let self = this;
    // We need to wait a bit to call reflow here; $nextTick seems to be the cleanest option.
    this.$nextTick(() => { self.$refs.chartComponent.chart.reflow(); });
  }
}
</script>

<style lang="scss" scoped>
.user-details-usage-history-chart.chart-container {
  padding: 10px 15px 0;
}
</style>
